export const tooltipNotificationCardComponenetsProps = {
  tooltip: { sx: { maxWidth: '325px', padding: '0 !important',borderRadius:'8px', } },
  arrow: {
    sx: {
      display: 'none !important'
    }
  }
}

